/**
 * THIS FILE IS GENERATED, DO NOT TOUCH!
 * Please put your changes into js/build/themeVariables/config.js
 */

// Timing
export const time = {base: '0.45s', short: '0.25s'};

// Timing in seconds
export const timeInSeconds = {base: 0.45, short: 0.25};

// Sizing variables
export const spacing = {
    none: 0,
    xxSmall: '0.25rem',
    xSmall: '0.5rem',
    small: '0.75rem',
    mSmall: '1rem',
    medium: '1.5rem',
    large: '2rem',
    mLarge: '2.5rem',
    xLarge: '4rem',
    xxLarge: '5.5rem',
    xxxLarge: '7.5rem',
    wrapper: '0.9375rem',
};

// Typography variables
export const fontWeight = {light: 300, regular: 400, semibold: 600, bold: 700};
export const fontSize = {
    h1: '2.25rem',
    h2: '2rem',
    h3: '1.5rem',
    h4: '1.125rem',
    h5: '1rem',
    h6: '1rem',
    t5: '0.9375rem',
    t6: '0.875rem',
    base: '1rem',
    input: '0.9375rem',
    sm: '0.75rem',
    xs: '0.625rem',
    xxl: '2.625rem',
};
export const lineHeight = {large: 1.75, base: 1.5, small: 1.25};

// Border radius variables
export const borderRadius = {base: '0.25rem', small: '0.125rem', medium: '0.375rem', large: '0.5rem', xLarge: '0.75rem'};

// Media Variables
// @todo Review breakpoints - 480 / 768 / 1024 / 1280 - these are based on the official Sass Styleguide
export const breakpoints = {xxs: 321, xs: 480, ms: 576, sm: 768, md: 992, ml: 1024, lg: 1200, xl: 1301, xxl: 1536, xxxl: 1800};

// Wrapper max-widths
export const wrapperWidth = {max: '75rem', md: '62.5rem', sm: '51.875rem', xs: '48.125rem'};

// Color names based on http://chir.ag/projects/name-that-color
export const COLOR_ASTRONAUT_BLUE = '#00385f';
export const COLOR_REGAL_BLUE = '#00497b';
export const COLOR_BAHAMA_BLUE = '#005b94';
export const COLOR_ALLPORTS = '#0069a7';
export const COLOR_DEEP_CERULEAN = '#0078b4';
export const COLOR_SHAKESPEARE = '#40a3d5';
export const COLOR_MALIBU = '#83d0f5';
export const COLOR_SAIL = '#bce4fa';
export const COLOR_HAWKES_BLUE = '#dff2fd';
export const COLOR_MONZA = '#e30613';
export const COLOR_BLACK = '#000';
export const COLOR_WHITE = '#fff';
export const COLOR_PRUSSIAN_BLUE = '#002243';
export const COLOR_MIDNIGHT_BLUE = '#036';
export const COLOR_CELLO = '#1f4266';
export const COLOR_CHATHAMS_BLUE = '#1b4875';
export const COLOR_CHAMBRAY = '#335c85';
export const COLOR_HIPPIE_BLUE = '#5b83ae';
export const COLOR_WAIKAWA_GRAY = '#5b799b';
export const COLOR_CASPER = '#aabacc';
export const COLOR_GEYSER = '#ccd7e1';
export const COLOR_MYSTIC = '#e6ebf0';
export const COLOR_CATSKILL_WHITE = '#f5f8fa';
export const COLOR_TROPICAL_BLUE = '#cde6f8';
export const COLOR_LILY_WHITE = '#e2f4fe';
export const COLOR_SANGRIA = '#9e0000';
export const COLOR_RED = '#ea0000';
export const COLOR_FLUSH_ORANGE = '#ff7900';
export const COLOR_ORANGE_PEEL = '#ffa200';
export const COLOR_LIMED_SPRUCE = '#313a45';
export const COLOR_DOVE_GRAY = '#666';
export const COLOR_DUSTY_GRAY = '#999';
export const COLOR_MERCURY = '#e5e5e5';
export const COLOR_FUEL_YELLOW = '#eca72c';
export const COLOR_GLACIER = '#84c0c6';
export const COLOR_MOUNTAIN_MEADOW = '#14c376';
export const COLOR_AQUA_HAZE = '#f4f8f9';
export const COLOR_SHUTTLE_GRAY = '#58646f';
export const COLOR_PALE_SKY = '#6b7783';
export const COLOR_BALI_HAI = '#90a0b2';
export const COLOR_DEFAULT_TEXT = '#2d3c4a';
export const COLOR_DISABLED = 'rgba(163, 181, 201, 0.5)';

// Horizontal position of carousel navigation arrows
export const SLIDER_ARROW_POS = '4.375rem';

// Grid gutter
export const GRID_GUTTER = '1.875rem';
export const GRID_GUTTER_PX = 30;

// z-index
export const zIndex = {dropdown: 10, sticky: 20, header: 30, modal: 40, tooltip: 50};
